enum Types {
  Request = 'login/REQUEST',
  Success = 'login/SUCCESS',
  Failure = 'login/FAILURE',
  Reset = 'login/RESET',
}

export default Types;
